function bigIntToNumber(value) {
  return Math.min(Number(value), Number.MAX_SAFE_INTEGER);
}
function minBigInt(...values) {
  let minValue = values[0];
  for (const value of values) {
    if (value < minValue) {
      minValue = value;
    }
  }
  return minValue != null ? BigInt(minValue) : void 0;
}
function maxBigInt(...values) {
  let maxValue = values[0];
  for (const value of values) {
    if (value > maxValue) {
      maxValue = value;
    }
  }
  return maxValue != null ? BigInt(maxValue) : void 0;
}

export { bigIntToNumber, maxBigInt, minBigInt };
